/**
 * Share API Service
 * Handles API calls for Twitter share boost feature
 */

import { getBackendUrl } from '../utils/backendUrl';

const BACKEND_URL = getBackendUrl();

export interface ShareBoostStatus {
  hasClaimedBoost: boolean;
  hasUnusedBoost: boolean;
  sessionIdUsed?: string | null; // Which session consumed the boost
  boostDetails?: {
    type: 'round2_multiplier';
    value: number;
    grantedAt: string;
  };
}

export interface ClaimBoostResponse {
  success: boolean;
  boost?: {
    type: 'round2_multiplier';
    value: number;
  };
  error?: string;
}

/**
 * Get user's share boost status
 */
export async function getBoostStatus(wallet: string): Promise<{
  success: boolean;
  data?: ShareBoostStatus;
  error?: string;
}> {
  try {
    const response = await fetch(`${BACKEND_URL}/api/share/status?wallet=${encodeURIComponent(wallet)}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('❌ SHARE API: Error fetching boost status:', error);
    return {
      success: false,
      error: 'Failed to fetch boost status'
    };
  }
}

/**
 * Claim share boost (called when user clicks tweet button)
 */
export async function claimBoost(wallet: string, shareType: string = 'twitter_round1_win'): Promise<ClaimBoostResponse> {
  try {
    const response = await fetch(`${BACKEND_URL}/api/share/claim`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        wallet,
        shareType
      })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('❌ SHARE API: Error claiming boost:', error);
    return {
      success: false,
      error: 'Failed to claim boost'
    };
  }
}

const shareApiService = {
  getBoostStatus,
  claimBoost
};

export default shareApiService;

